import { FC, ReactNode } from "react";
import { Content } from "@jobber/components/Content";
import { Heading } from "@jobber/components/Heading";
import { Flex } from "@jobber/components/Flex";
import { Text } from "@jobber/components/Text";
import { ProgressBar } from "@jobber/components/ProgressBar";
import { Button } from "@jobber/components/Button";
import { Spinner } from "@jobber/components/Spinner";
import { AuthFlowButton } from "../../types";
import { useBreakpoints } from "@jobber/hooks/useBreakpoints";

type AuthFlowProps = {
    readonly children: ReactNode | ReactNode[];
    pretitle: string,
    title: string,
    step: number,
    totalSteps: number,
    button: AuthFlowButton,
    secondaryButton?: AuthFlowButton,
};

const AuthFlowFrame: FC<AuthFlowProps> = ({
    children,
    pretitle,
    title,
    step,
    totalSteps,
    button,
    secondaryButton,
}) => {
    let breakpoints = useBreakpoints();

    return (
        <div
            style={{
                width: "100%",
                padding: "40px",
                display: "flex",
                gap: "40px",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <Content spacing={"larger"}>
                <Content spacing={"base"}>
                    <Heading level={4}>{pretitle}</Heading>
                    <Heading level={1}>{title}</Heading>
                </Content>
                <div
                    style={{
                        maxWidth: "715px",
                        minHeight: "317px",
                    }}
                >
                    {children}
                </div>

                <div
                    id={"errors"}
                    style={{
                        display: "flex",
                        gap: "10px",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                ></div>
            </Content>

            <Content spacing={"base"}>
                <Flex
                  align={"end"}
                  gap={"small"}
                  template={["grow", "shrink"]}
                  direction={breakpoints.mediumAndUp ? "row" : "column"}
                >
                    <Content spacing={"smaller"}>
                        <Text size="base">Step <b>{step}</b> of <b>{totalSteps}</b></Text>
                        <div
                            style={{
                                maxWidth: breakpoints.mediumAndUp ? "375px" : "100%"
                            }}
                        >
                            <ProgressBar currentStep={step} totalSteps={totalSteps} />
                        </div>
                    </Content>

                    <Flex
                      gap={"none"}
                      template={["grow", "shrink"]}
                    >
                        <div style={{
                            justifySelf: "flex-end",
                            marginLeft: "8px",
                        }}>
                            <Flex
                              gap={secondaryButton === undefined ? "none" : "small"}
                              template={["grow", "shrink"]}
                            >
                                {
                                    secondaryButton !== undefined &&
                                        <Button
                                            url={secondaryButton.link}
                                            label={secondaryButton.text}
                                            type={secondaryButton.type}
                                            disabled={secondaryButton.disabled}
                                            loading={secondaryButton.loading}
                                            onClick={secondaryButton.onClick}
                                        />
                                }
                                {
                                    button.link
                                        ? <Button
                                            url={button.link}
                                            label={button.text}
                                            type={button.type}
                                            disabled={button.disabled}
                                            loading={button.loading}
                                            onClick={button.onClick}
                                        />
                                        : <div style={{marginTop: "6px"}}>
                                            <Spinner size={"base"} inline={true} aria-label={"Loading"} />
                                        </div>
                                }
                            </Flex>
                        </div>
                    </Flex>
                </Flex>
            </Content>
        </div>
    );
};

export default AuthFlowFrame;